<template>
  <ul
    class="CNl7QD1FpnStvA1noMH8"
    :style="deviceInfo.mobile ? 'position:fixed;' : ''"
    :class="
      $store.state.config.ui_version == '3.1' ||
      ['3.8','3.8_2'].includes($store.state.config.ui_version)
        ? 'CNl7QD1FpnStvA1noMH8Sandian1'
        : ''
    "
  >
    <li
      v-for="(item, index) in sidebarsList"
      class="sidebars-List"
      :key="index"
      v-if="item.isShow"
    >
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        :show-indicators="false"
      >
        <van-swipe-item
          @click="openUrl(item_sy)"
          v-if="item_sy !== true"
          v-for="(item_sy, index1) in item"
          :key="index1"
        >
          <img v-lazy="item_sy.image" class="im" alt="" />
        </van-swipe-item>
      </van-swipe>
      <p class="KXUP_IukrjksI9v7ohfA" @click="item.isShow = false">
        <img
          style="width: 0.35rem;height: 0.35rem; margin-top: 0.1rem;margin-right: 2.0rem;"
          v-lazy="fanhuisems"
          alt=""
        />
        <svg-icon
          v-if="0"
          className="svg"
          icon-class="comm_icon_x--svgSprite:all"
        />
      </p>
    </li>
    <li
      @click="homeScrollbar"
      class="menmes"
      style="padding-top: 0.1rem"
      v-if="$store.state.Returntotop"
    >
      <div class="LgFw5l227MkKBKpLD64g float-bar">
        <div>
          <div class="GO6MyZdeydW4ZcSgnvkK float-bar__icon-wrap">
            <svg-icon
              className="svg"
              icon-class="comm_icon_fhdb--svgSprite:all"
            />
          </div>
          <div
            v-if="['3.1','3.8','3.8_2'].includes($store.state.config.ui_version)"
            class="oBV4WKCvUQyDmGdMy1nT float-bar__title"
          >
            TOPO
          </div>
          <div class="oBV4WKCvUQyDmGdMy1nT float-bar__title" v-else>
            {{ $t('components._Topo') }}
          </div>
        </div>
      </div>
    </li>
    <li
      @click="homeScrollbar"
      class="menmes3_7"
      style="padding-top: 0.1rem"
      v-if="$store.state.Returntotop"
    >
      <div
        class="LgFw5l227MkKBKpLD64g float-bar"
        :style="{
          'background-image': `url(${aoarrnimym})`
        }"
      >
        <!-- a0he3-tgjjt.png -->
        <!-- aoarrnimym -->
        <div>
          <img
            :src="fanhuis"
            alt=""
            style="
              width: 0.27rem;
              height: 0.4rem;
              margin: 0 auto;
              display: block;
            "
            sizes=""
            srcset=""
          />
          <div
            v-if="['3.1','3.8','3.8_2'].includes($store.state.config.ui_version)"
            class="oBV4WKCvUQyDmGdMy1nT float-bar__title"
          >
            TOPO
          </div>
          <div v-else class="oBV4WKCvUQyDmGdMy1nT float-bar__title">
            {{ $t('components._TOPO_1') }}1
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';
import { Toast } from 'vant';
import { userInfo } from '@/apis/modules/home.js';
export default {
  props: {
    sidebarsList: {
      type: [Object, Array],
      required: {}
    }
  },
  data() {
    return {
      codeValue: '',
      aoarrnimym: require('./../../assets/4Ddian/a0he3-tgjjt.png'),
      fanhuis: require('./../../assets/4Ddian/akk9s-l4d85.png'),
      fanhuisems: require('./../../assets/a83cu-6jp7l.png'),
      inputFocus: false,
      deviceInfo: {}
    };
  },
  created() {
    this.deviceInfo = this.getDeviceInfo();
  },
  computed: {
    ...mapState(['vuex_token_head','userInfo'])
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if(this.$store.state.config.goto_bind_ws && this.userInfo.id && !this.userInfo.bind_ws && this.$store.state.config.bind_ws){
        userInfo({}).then(({ data,code }) => {
          if(code == 0){
            this.$store.state.config.goto_bind_ws = false;
            this.$store.commit('userInfo', data);
          }
        });
      }
    },
    getDeviceInfo() {
      let u = navigator.userAgent, app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信
        qq: u.match(/\sQQ/i) == ' qq' //是否QQ
      };
    },
    homeScrollbar() {
      this.homeScrollbarDom.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    },
    handleScroll(e) {
      //console.log(e);
    },
    async openUrl(e) {
      if (e.isJumpUrl) {
        window.open(e.jump_url, '_blank');
      } else if (e.jump_url && e.jump_url != '#') {
        // 跳转富文本
        if (e.jump_url == 'richText') {
          this.$router.push({
            name: 'details',
            query: {
              title: e.title,
              content: e.content
            }
          });
          return;
        }
        if (e.jump_url == 'pdd') {
          this.$store.state.isShowWheelSpinEvent = true;
          return false;
        }
        if (e.jump_url == 'dailySignIn') {
          this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
          return false;
        }
        if (e.jump_url == 'recharge') {
          this.$store.commit('isDeposit', true);
          return false;
        }
        if (this.$store.state.config.service_need_bind && (e.jump_url.startsWith('https://t.me') || e.jump_url.startsWith('https://wa.me'))) {
          let needBind = false;
          if (this.vuex_token_head && this.$store.state.config.bind_ws) {
            let isStop = false,msg = '';
            if(this.userInfo.bind_ws){
              // 是否持续绑定中
              if(this.$store.state.config.check_bind){
                try{
                  this.$store.commit('sLoading', true);
                  const response = await fetch(this.$store.state.config.check_bind+'?user_id='+this.userInfo.id+'&domain='+window.location.hostname);
                  // 检查 HTTP 响应状态 (fetch 不会自动把 404/500 变成错误)
                  if (!response.ok) {
                    isStop = true,msg = 'Por favor, tente novamente.';
                  }else{
                    const resData = await response.text();
                    if(resData == 'Proxy-Retry'){
                      isStop = true,msg = 'Por favor, tente novamente.';
                    }else if(resData == 'Not-Found' || resData == 'flase'){
                      needBind = true,msg = 'Por favor, vincule sua conta WhatsApp primeiro para garantir a segurança da sua conta.';
                    }
                  }
                }catch(error){
                  isStop = true,msg = 'Por favor, tente novamente.';
                }finally{
                  this.$store.commit('sLoading', false);
                }
              }
            }else{
              needBind = true,msg = 'Por favor, vincule sua conta WhatsApp primeiro para garantir a segurança da sua conta.';
            }

            // 需要提示信息
            if(msg){
              Toast.fail({message: this.myLineBreaks(msg),duration: 2000});
              if(isStop)return;
            }
          }
          // 需要绑定
          if(needBind){
            this.$store.state.config.goto_bind_ws = true;
            this.$router.push({
              name: 'webviewCommon',
              params: {
                url: this.$store.state.config.bind_ws+'/'+window.location.hostname+'/'+this.userInfo.id
              }
            });
          }else{
            window.open(e.jump_url, '_blank');
          }
          return false;
        }else if (/^http/.test(e.jump_url)) {
          window.open(e.jump_url, '_blank');
          return false;
        }
        this.$router.push({ name: e.jump_url });
      }
    }
  }
};
</script>

<style scoped>
.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List,
.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List .im {
  width: 1.2rem !important;
  height: 1.2rem !important;
}
.CNl7QD1FpnStvA1noMH8Sandian1 .LgFw5l227MkKBKpLD64g {
  margin-left: 0.1rem;
  opacity: 0.9;
}

.csapp37 .LgFw5l227MkKBKpLD64g {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
}
.csapp37 .LgFw5l227MkKBKpLD64g {
  width: 0.9rem;
  height: 0.84rem;
  max-height: 0.84rem;
  min-height: auto !important;
  box-sizing: border-box;
  max-width: 0.9rem;
}
.csapp37 .oBV4WKCvUQyDmGdMy1nT {
  color: var(--skin__text_primary) !important;
}
.LgFw5l227MkKBKpLD64g {
  background-color: var(--theme-main-bg-color);
  border: 0.01rem solid var(--theme-color-line);
  background-size: 100% 100%;
  border-radius: 0.1rem;
  -webkit-box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 0.78rem;
  padding: 0.1rem;
  width: 0.84rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.LgFw5l227MkKBKpLD64g {
  min-height: 1rem;
  padding: 0.14rem 0.1rem;
  box-sizing: border-box;
  width: 1.1rem;
  margin-left: 0.2rem;
}

.GO6MyZdeydW4ZcSgnvkK {
  height: 0.38rem;
  width: 0.38rem;
  margin: 0 auto;
}
.GO6MyZdeydW4ZcSgnvkK {
  background-color: var(--theme-primary-color);
  border-radius: 50%;
  color: var(--theme-primary-font-color);
  font-size: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.08rem;
}
.oBV4WKCvUQyDmGdMy1nT {
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  font-size: 0.2rem;
  -webkit-box-orient: vertical;
  color: var(--theme-text-color-lighten);
  display: -webkit-box;
  font-size: 0.18rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 100%;
}
.GO6MyZdeydW4ZcSgnvkK svg {
  width: 0.2rem;
  height: 0.2rem;
}
.CNl7QD1FpnStvA1noMH8 {
  position: absolute;
  bottom: 1.31rem;
  z-index: 99;
  right: 0.1rem;
}

.CNl7QD1FpnStvA1noMH8 .sidebars-List {
  width: 1.2rem;
  height: 1.2rem;
  position: relative;
  margin-top: 0.2rem;
}

.CNl7QD1FpnStvA1noMH8 .sidebars-List .im {
  width: 1.2rem;
  height: 1.2rem;
}

.KXUP_IukrjksI9v7ohfA {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  /* border: 0.01rem solid var(--theme-text-color-lighten); */
  border-radius: 50%;
  display: -ms-flexbox;
  display: flex;
  height: 0.2rem;
  justify-content: center;
  position: absolute;
  right: 0;
  z-index: 9999;
  top: 0;
  width: 0.2rem;
}

.KXUP_IukrjksI9v7ohfA .svg {
  color: var(--theme-text-color-lighten);
  height: 0.08rem;
  width: 0.08rem;
}
.menmes3_7 {
  display: none;
}
.csapp37 .menmes {
  display: none;
}
.csapp37 .menmes3_7 {
  display: block;
}
</style>
